module.exports = __webpack_public_path__ + "static/header-text-3c57409a251bbfdbdc73eda959a4436e.svg";